import { useAppSelector } from '@store/hooks'
import { selectSelectedMembershipProfile } from '@store/membership/MembershipProfileReducer'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { emailRule, requiredRule } from '@utils/rules'
import {
  Alert,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Segmented,
  theme,
} from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { langList } from '../../../../factories/Utils'
import MembershipProfile from '../MembershipProfile'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const { token } = theme.useToken()
  const item = useAppSelector(selectSelectedMembershipProfile())

  useEffect(() => {
    form.setFieldsValue({
      ...item,
      birthDate: dayjs(item?.birthDate),
    })
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="isActive" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            name="firstName"
            rules={[requiredRule()]}
            label={'First name'}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="lastName"
            rules={[requiredRule()]}
            label={'Last name'}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            name="birthDate"
            rules={[requiredRule()]}
            label="Birth date"
          >
            <DatePicker format={'DD/MM/YYYY'} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="phone" rules={[requiredRule()]} label="Phone">
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        name="email"
        rules={[requiredRule(), emailRule()]}
        label="Email"
      >
        <Input />
      </Form.Item>

      <Form.Item name="locale" rules={[requiredRule()]} label="Locale">
        <Segmented
          options={langList.map((lang) => ({
            value: lang.code,
            label: `${lang.flag} ${lang.name}`,
          }))}
          block
        />
      </Form.Item>

      <Form.Item name="cardNumber" rules={[]} label="Card Number">
        <Input maxLength={5} showCount />
      </Form.Item>
      <Alert
        title={
          <MembershipProfile.WalletDisclaimer
            style={{ color: token.colorText }}
          />
        }
      />
    </Form>
  )
}

export default Update
